$shm_hitalama_map_widget_float_ai_request_component $shm_hitalama_map_widget_float_ai_request_form
	sub /
		<= App_label $mol_labeler
			title \Описание приложения
			content /
			Content <= App $mol_textarea
				value? <=> text?
	create_md* null
	create_view* null
	parse_css_selectors* null
	create_classes* null
	next_request_type \changes_short
